﻿
export class UserModel {
  id: string;
  contactName: string;
  userId: string;
  username: string;
  role: string;
}